import { MapPin } from 'lucide-react'
import { ComponentProps } from 'react'
import { webchatClasses } from '../../../styles/classes'
import { LocationBlock, type CommonBlockProps } from '../../../types'

type Props = LocationBlock & CommonBlockProps & ComponentProps<'a'>

export const Location = ({ ref, latitude, longitude, title, isReadOnly, ...props }: Props) => {
  const link = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`

  const {
    message: {
      blocks: { location },
    },
  } = webchatClasses

  return (
    <a
      {...props}
      {...location.container}
      style={isReadOnly ? { pointerEvents: 'none' } : undefined}
      href={link}
      type="_blank"
      rel="noopener"
      ref={ref}
    >
      <p {...location.title}>{title}</p>
      <MapPin {...location.icon} />
    </a>
  )
}

Location.displayName = 'Location'
